import React, { ReactElement, useCallback, useEffect, useState } from "react";
import SearchInput from "../../components/common/SearchInput";

import styles from "./index.module.css";
import { Recipient } from "../../types/recipient";
import { getIntercomUsersByUrlId, requestCallReq } from "../../api/requests";
import { UserIcon } from "../../components/icons/UserIcon";
import { FullPageLoader } from "../../components/common/FullPageLoader";
import { highlightMatch } from "../../utils/highlight-match";
export const PorttelefonPage: React.FC = (): ReactElement => {
  // Extract everything after the first slash from the current URL
  const urlId = window.location.pathname.substring(1);
  const [isLoading, setIsLoading] = useState(true);
  const [users, setUsers] = useState<Recipient[]>([]);
  const [voxnodePhone, setVoxnodePhone] = useState<string>("");
  const [locationAddress, setLocationAddress] = useState<string>("");
  const [intercomId, setIntercomId] = useState<number | null>(null);
  const [searchInput, setSearchInput] = useState("");
  const filteredUsers = users.filter((user) =>
    `${user.name} ${user.surname}`
      .toLowerCase()
      .includes(searchInput.toLowerCase())
  );

  const setSearchInputHandler = (search: string) => {
    setSearchInput(search);
  };

  const fetchUsers = useCallback(async () => {
    try {
      if (urlId) {
        const response = await getIntercomUsersByUrlId(urlId);
        setUsers(response.data?.users || []);
        setVoxnodePhone(response.data?.voxnodePhone || "");
        setLocationAddress(response.data?.locationAddress || "");
        setIntercomId(response.data?.intercomId ?? null);
      }
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false);
  }, [urlId]);

  const triggerCall = async (recipientId: number) => {
    if (urlId) {
      await requestCallReq(recipientId, urlId);
    } else {
      console.error("urlId is undefined");
    }
  };

  useEffect(() => {
    console.log("Fetching users for URL ID:", urlId);
    fetchUsers();
  }, [fetchUsers, urlId]);

  return (
    <div className={styles.root}>
      <FullPageLoader show={isLoading} />
      <>
        <div className={styles.header}>
          <h1 className={styles.title}>Porttelefon</h1>
          {(locationAddress || intercomId != null) && (
            <h2 className={styles.subtitle}>{locationAddress || intercomId}</h2>
          )}
        </div>
        <div className={styles.inputContainer}>
          <SearchInput
            searchInput={searchInput}
            setSearchInputHandler={setSearchInputHandler}
          />
        </div>
        <div className={styles.list}>
          {filteredUsers.map((user) => {
            const id = user.id;
            const name = [user.name, user.surname].filter(Boolean).join(" ") || "No Name";
            const highlightedName = highlightMatch(name, searchInput);

            if (!id) return null;

            return (
              <div key={user.id} className={styles.listItem}>
                <div className={styles.nameContainer}>
                  <UserIcon />
                  <h3 className={styles.name}>{highlightedName}</h3>
                </div>

                <a
                  href={`tel:${voxnodePhone}`}
                  onClick={() => triggerCall(+id)}
                >
                  <img src="/assets/call-icon.png" alt="Call" height={50} />
                </a>
              </div>
            );
          })}
        </div>
      </>
    </div>
  );
};
